// extracted by mini-css-extract-plugin
export var container = "_5g-1";
export var editor = "_5g-2";
export var resizable = "_5g-3";
export var wrapper = "_5g-0";